// RecipeContext.js
import React, { createContext, useState } from 'react';

// Create the context
export const PostContext = createContext();

// Create a provider component
export const PostProvider = ({ children }) => {
  // Initialize the state that will hold the recipe data
  const [postData, setPostData] = useState({
    title: '',
    summary: '',
    content: '',
    file: null,
    ingredients: [{ name: '', amount: '', unit: '' }],
    instructions: [''],
    notes: [''],
    additionalInfo: {
      prepTime: '',
      cookTime: '',
      category: '',
      method: '',
      cuisine: '',
      serving: ''
    },
    postType: 'article', 
    category: '',
    visability: 'public'
  });

  // Function to update the recipe data
  const updatePostData = (newData) => {
    setPostData((prevData) => ({ ...prevData, ...newData }));
  };

  return (
    <PostContext.Provider value={{ postData, updatePostData }}>
      {children}
    </PostContext.Provider>
  );
};
